import { PopularImages } from "@components/popular-images";
import { Blockquote, Heading, TextArea } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import { AdvancedMode } from "../components/advanced-mode";
import { FileInputOrLink } from "../components/file-input-or-link";
import { ModeBaseProps } from "./types";

export const TryonMode = ({
  fromImage,
  setFromImage,
  promptTxt,
  setPromptTxt,
}: ModeBaseProps & {
  promptTxt: string;
  setPromptTxt: (value: string) => void;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="space-y-2">
        <FileInputOrLink
          heading={t("camera.form.tryon.clothing")}
          fromImage={fromImage}
          setFromImage={setFromImage}
        />
        <Blockquote size="2">{t("camera.form.tryon.description")}</Blockquote>
        <Blockquote size="2">{t("camera.form.tryon.description2")}</Blockquote>
      </div>

      <AdvancedMode startOpen={!!promptTxt}>
        <div className="space-y-2">
          <Heading size="3">{t("camera.form.prompt.title")}</Heading>
          <TextArea
            placeholder={t("camera.form.prompt.placeholder")}
            size="3"
            resize={"vertical"}
            value={promptTxt}
            onChange={(e) => setPromptTxt(e.target.value)}
          />
          <Blockquote size="2">
            {t("camera.form.prompt.description")}
          </Blockquote>
        </div>
      </AdvancedMode>

      {false && (
        <PopularImages
          type="image_outfit"
          onChange={(item) => setFromImage(item.url)}
        />
      )}
    </>
  );
};
